<template>
<NuxtLink :to="{path:'/projets',query:{categories: theme.categorie}}" class="themes__item">
    <div class="themes__item__icon"  :class="`icon-${theme.picto}`" aria-hidden="true">
    </div>
    <h3 class="themes__item__title" v-html="theme.titre"></h3>
    <ul class="themes__item__content">
       <div v-html="theme.contenu"></div>
    </ul>
</NuxtLink>
</template>
<script setup lang='ts'>
import type { Competence } from '~/types/options';

 const props = defineProps<{
    theme : Competence
}>()

</script>
<style lang="scss">
    .themes__item{
        flex: 0 0 calc(25% - 2rem);
        @media screen and (max-width:1035px) {
            flex:  0 0 calc(50% - 2rem);
            &:nth-child(1),&:nth-child(2){
                margin-bottom: 30px;
            }
        }
        @media screen and (max-width:550px) {
            flex:  0 0 100%;
            &:not(:last-child){
                margin-bottom: 30px;
            }
        }
        &__icon{
            display: block;
            margin: 0 auto 20px auto;
            width: 60px;
            height: 60px;
            background-size: contain;
            background-repeat: no-repeat;
            background-position: center center;
            transition: all .4s ease;
            &.icon-habillage{
                background-image: url('~/assets/svgs/picto-habillage.svg');
            }
            &.icon-culture{
                background-image: url('~/assets/svgs/picto-culture-expo.svg');
            }
            &.icon-communication{
                background-image: url('~/assets/svgs/picto-communication-visuelle.svg');
            }
            &.icon-illustration{
                background-image: url('~/assets/svgs/picto-illustration.svg');
            }
        }
        &__title {
            color: $violet;
            font-family: 'Playfair Display',serif;
            font-weight: 900;
            font-size: 24px;
            line-height: 28px;
            margin: 0 auto 20px auto;
            text-align: center;
            @media screen  and (max-width:550px) {
                font-size: 20px;
                line-height: 24px;
            }
        }
        &__content{
            padding: 0;
            list-style-type: none;
            text-align: center;
            li{
                color: $text_light;
                font-weight: 600;
                font-size: 16px;
                &:not(:last-child){
                    margin-bottom: 5px;
                }
            }
        }
        &:hover{
            .themes__item__icon{
                transform: rotate(180deg) ;
            }
        }
    }
</style>